import { Routes } from '@angular/router';
import { OAuthLayoutComponent } from '../layouts/oauth/oauth-layout.component';
import { OAuthAuthComponent } from '../features/oauth/pages/oauth-auth/oauth-auth.component';
import { OAuthConsentComponent } from '../features/identity/pages/oauth-consent/oauth-consent.component';

/**
 * Thin IdP surface for Login with Valvur (kid / subject sign-in + consent).
 * Hosted on oauth.* — parallel to family / patrol / admin.
 *
 * Gateway redirects partners to `{OAUTH_CONSENT_WEB_URL}/oauth/consent?...`
 * No AuthGuard on consent: component stores return URL then redirects to /auth.
 */
export function getOAuthRoutes(): Routes {
  return [
    {
      path: '',
      component: OAuthLayoutComponent,
      data: { layout: 'oauth' },
      children: [
        {
          path: '',
          pathMatch: 'full',
          redirectTo: 'auth',
        },
        {
          path: 'auth',
          component: OAuthAuthComponent,
        },
        {
          path: 'oauth/consent',
          component: OAuthConsentComponent,
        },
      ],
    },
  ];
}
